import React from "react";
import EditorNumber from "./numbers/EditorNumber";

const NumberCountSelector = (props) => {

    const createSelections = () => {
        var result = [];
        for (var i = 1; i <= props.max; i++) {
            result.push(<EditorNumber key={i} onClickNumber={props.onSelect} className="smallNumber" selected={props.count === i} number={i}></EditorNumber>)
        }
        return result;
    };
    return (
        <div className="grid10">
            {createSelections()}     
        </div>
    );
};

export default NumberCountSelector;